import doc                        from '@widesk-core/decorators/doc';
import model                      from '@widesk-core/decorators/model';
import NetworkServiceModel        from '@/models/NetworkServiceModel';
import RelationModel              from './RelationModel';
import RelationStatusModel        from './RelationStatus';

@model.urnResource('relation_status_history')
@doc.path('/relation_status_histories/{?id}')
export default class RelationStatusHistoryModel extends NetworkServiceModel {
	private declare _tsFilters: {
		'createdAt[after]': string;
		'createdAt[before]': string;
		'createdAt[strictly_after]': string;
		'createdAt[strictly_before]': string;
		'relation': id;
		'relationStatus': id;
		'id': id;
		'updatedAt[after]': string;
		'updatedAt[before]': string;
		'updatedAt[strictly_after]': string;
		'updatedAt[strictly_before]': string;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'updatedAt': string;
	};

	@doc.model(RelationModel) declare relation: RelationModel;
	@doc.model(RelationStatusModel) declare relationStatus: RelationStatusModel;
}